import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

type Props = {
  hidePlayer?: boolean;
};

const SearchContainer = styled.div<Props>(({ hidePlayer, theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.gray['100'],
  bottom: hidePlayer ? 0 : '7.5rem',
  display: 'flex',
  height: 'auto',
  justifyContent: 'center',
  left: 0,
  position: 'fixed',
  top: '5.8rem',
  width: '100%',
  zIndex: theme.zIndex.search,

  [mediaQueryBuilder(theme.mediaQueries.max.width['599'])]: {
    top: '9.6rem',
  },
}));

export default SearchContainer;
